export default __webpack_public_path__ + "static/media/GuestyLiteDarkLogo.56de9b7b.png";